/**
 * @generated SignedSource<<a3b3e76c837a33379bfe8e56649c0a22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkUpdatePhasePortalConfigInput = {
  phases: ReadonlyArray<PhasePortalConfigInput>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type PhasePortalConfigInput = {
  psaMilestoneId: string;
  clientOrgId?: string | null;
  psaProjectId?: string | null;
  legacyPsaProjectId?: string | null;
  requiresClientSignoff?: boolean | null;
  signoffApproverForecastPersonId?: number | null;
};
export type bulkUpdatePhasePortalConfigMutation$variables = {
  input: BulkUpdatePhasePortalConfigInput;
};
export type bulkUpdatePhasePortalConfigMutation$data = {
  readonly bulkUpdatePhasePortalConfig: {
    readonly phasePortalConfigs: ReadonlyArray<{
      readonly psaMilestoneId: string | null;
      readonly requiresClientSignoff: boolean | null;
      readonly signoffApproverForecastPersonId: number | null;
      readonly signoffLocked: boolean | null;
    } | null> | null;
  } | null;
};
export type bulkUpdatePhasePortalConfigMutation = {
  variables: bulkUpdatePhasePortalConfigMutation$variables;
  response: bulkUpdatePhasePortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkUpdatePhasePortalConfigPayload",
    "kind": "LinkedField",
    "name": "bulkUpdatePhasePortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhasePortalConfig",
        "kind": "LinkedField",
        "name": "phasePortalConfigs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "psaMilestoneId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiresClientSignoff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signoffApproverForecastPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signoffLocked",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkUpdatePhasePortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkUpdatePhasePortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5301f48a59151145aaf2a57ca368dd90",
    "id": null,
    "metadata": {},
    "name": "bulkUpdatePhasePortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation bulkUpdatePhasePortalConfigMutation(\n  $input: BulkUpdatePhasePortalConfigInput!\n) {\n  bulkUpdatePhasePortalConfig(input: $input) {\n    phasePortalConfigs {\n      psaMilestoneId\n      requiresClientSignoff\n      signoffApproverForecastPersonId\n      signoffLocked\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "637d05f534d6e6064d90d2fb05e46d8a";

export default node;
